export enum FOSCategoryTypeSubscriptions {
  OPEN_BK = 41,
  TRADING_INSTRUMENTS = 42,
  MOBILE_APP = 43,
  RESTORATION_TRADING = 44,
}
